import { useEffect } from "react";
import BlazeSlider from "blaze-slider";
import "blaze-slider/dist/blaze.css";

const testimonials = [
  {
    id: 1,
    userImage: "https://avatars.githubusercontent.com/u/74861009?v=4",
    title: "CEO, Klas HQ",
    message:
      "Lorem ipsum dolor sit amet consectetur. Tristique malesuada tortor pulvinar eu luctus pharetra scelerisque donec mattis",
  },
  {
    id: 2,
    userImage: "https://avatars.githubusercontent.com/u/74861009?v=4",
    title: "PM, Zap Delivery",
    message:
      "Lorem ipsum dolor sit amet consectetur. Tristique malesuada tortor pulvinar eu luctus pharetra scelerisque donec mattis",
  },
  {
    id: 3,
    userImage: "https://avatars.githubusercontent.com/u/74861009?v=4",
    title: "PM, Klas HQ",
    message:
      "Lorem ipsum dolor sit amet consectetur. Tristique malesuada tortor pulvinar eu luctus pharetra scelerisque donec mattis",
  },
  {
    id: 4,
    userImage: "https://avatars.githubusercontent.com/u/74861009?v=4",
    title: "CEO, Zap Delivery",
    message:
      "Lorem ipsum dolor sit amet consectetur. Tristique malesuada tortor pulvinar eu luctus pharetra scelerisque donec mattis",
  },
];

const Testimonial = () => {
  useEffect(() => {
    const element: HTMLElement = document.getElementById("blazeContainer")!;
    new BlazeSlider(element, {
      all: {
        enableAutoplay: true,
        autoplayInterval: 3000,
        transitionDuration: 1000,
        slidesToShow: 2,
      },
      "(max-width: 500px)": {
        slidesToShow: 1,
      },
    });
  }, []);
  return (
    <div className="px-6 lg:px-80 py-20 lg:py-12 border-b border-border">
      <div className="w-full lg:max-h-[800px] mx-auto">
        <div className="w-full lg:flex items-center justify-center lg:space-x-5"></div>
        <div className="blaze-slider" id="blazeContainer">
          <div className="blaze-container">
            <div className="blaze-track-container">
              <div className="blaze-track">
                {testimonials.map((testimonial) => {
                  return (
                    <div className={`p-6 lg:p-12 rounded-lg border`}>
                      <h1 className="text-primaryBlack font-medium text-lg">
                        "{testimonial.message}"
                      </h1>
                      <div className="flex items-center mt-5 space-x-3">
                        <img
                          alt=""
                          src={testimonial.userImage}
                          className="w-12 h-12 rounded-full"
                        />
                        <span>{testimonial.title}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="my-structure flex items-center justify-between mt-5">
                <button
                  className="blaze-prev py-2 px-3 rounded-full"
                  aria-label="Go to previous slide"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 19.5L8.25 12l7.5-7.5"
                    />
                  </svg>
                </button>
                <button
                  className="blaze-next text-black py-2 px-3 rounded-full"
                  aria-label="Go to next slide"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 text-white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
